import styled from 'styled-components';

export const PlateTitle = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
`;

export const PlateSubTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const RowWrap = styled.div``;
export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: rgba(9, 21, 38, 0.6);
  text-transform: uppercase;
`;
export const ItemsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;
`;
export const Card = styled.div<{ isNew?: boolean }>`
  width: 184px;
  height: 184px;
  background: ${(props) => (props.isNew ? '#D9F4E6' : '#f4f5f6')};
  border-radius: 8px;
  padding: 12px;
  display: inline-block;

  &:hover {
    cursor: pointer;
    background: #e0f5fb;
  }
`;
export const Cover = styled.div`
  width: 160px;
  height: 94px;
  background: #00c4b4;
  border-radius: 9px;
  background-size: cover;
`;
export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(9, 21, 38, 0.6);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AboutRulesWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const Ul = styled.ul`
  list-style-type: disc;
  list-style-position: inside;

  li {
    padding-left: 10px;
    line-height: 22px;
    &::marker {
      content: '•';
      padding-left: 4px;
      letter-spacing: 10px;
    }
  }
`;
